/**
 * @generated SignedSource<<81b3bf3a9051c3970ca3d32e1f7932c8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type add_or_edit_provider_params = {
  ingestion_config?: any | null;
  provider_id?: number | null;
  provider_name: string;
  provider_type_id: number;
};
export type addEditProviderMutation$variables = {
  params: add_or_edit_provider_params;
};
export type addEditProviderMutation$data = {
  readonly _sys_add_or_edit_provider: {
    readonly provider_id: number;
    readonly provider_name: string;
    readonly provider_type_id: number;
  };
};
export type addEditProviderMutation = {
  response: addEditProviderMutation$data;
  variables: addEditProviderMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "params"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "params",
        "variableName": "params"
      }
    ],
    "concreteType": "add_or_edit_provider_output",
    "kind": "LinkedField",
    "name": "_sys_add_or_edit_provider",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider_name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "provider_type_id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addEditProviderMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addEditProviderMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "af099dcbb1ed6d71ae3a845ef1883575",
    "id": null,
    "metadata": {},
    "name": "addEditProviderMutation",
    "operationKind": "mutation",
    "text": "mutation addEditProviderMutation(\n  $params: add_or_edit_provider_params!\n) {\n  _sys_add_or_edit_provider(params: $params) {\n    provider_id\n    provider_name\n    provider_type_id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0efec94fece5eab60fb6d97b9ea2f24b";

export default node;
